<!---------- Stepper Form ------------------------------- -->
<div class="row">
  <div class="col-sm-12">
    <div class="content-header">Lead Form</div>
  </div>
</div>
<section id="ngx">
  <div class="card">
    <div class="card-content">
      <div class="card-body">

        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <aw-wizard-step [stepTitle]="'Outsource Lead Info'"
            [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }">
            <form #outsourceForm="ngForm" class="editForm" novalidate>
              <br />
              <div class='row needs-validation'>
                <div class='col-12'>
                  <div class="row">
                    <div class='col-12 col-sm-6'>
                      <div class="form-group">
                        <label class="form-control-label" for="title">Title<span class="required_field">*</span></label>
                        <input class="form-control input-md" ngModel #title="ngModel"
                          [(ngModel)]="outsource_lead_model.title" [ngModelOptions]="{standalone: true}" required
                          id="title" name="title" type="text" placeholder="Enter title">
                        <small class="form-text text-muted danger"
                          *ngIf="!title.valid && (title.dirty || title.touched)">title is required!</small>
                      </div>
                      <!-- <div class="form-group"> // new Validation code
                                              <label for="validationTooltip01">Title</label>
                                              <input type="text" name="fname" class="form-control" id="validationTooltip01" [(ngModel)]="outsource_lead_model.title"  ngModel #title="ngModel"
                                              [ngClass]="{ 'is-invalid': !title.valid, 'is-valid': title.valid }" required>
                                              <small *ngIf="title.valid" class="valid-tooltip">Looks good!</small>
                                            </div>                                         -->
                    </div>
                    <div class='col-12 col-sm-6'>
                      <label class="form-control-label" for="links">Links</label>
                      <input class="form-control input-md" ngModel #links="ngModel"
                        [(ngModel)]="outsource_lead_model.links" [ngModelOptions]="{standalone: true}" required
                        id="links" name="links" type="text" placeholder="Enter links">
                    </div>
                  </div>
                  <!-- <div class='form-group'> -->
                  <div class="row">
                    <div class='col-12 col-sm-6'>
                      <div class="form-group">
                        <label class="form-control-label" for="date">Date</label>
                        <input class="form-control input-md" ngModel #date="ngModel"
                          [(ngModel)]="outsource_lead_model.date" [ngModelOptions]="{standalone: true}" required
                          id="date" name="date" type="date" placeholder="Enter date">
                        <!-- <small class="form-text text-muted danger" *ngIf="!date.valid && (date.dirty || date.touched)">date is required!</small> -->
                      </div>
                    </div>
                    <div class='col-12 col-sm-6'>
                      <label>Source</label>
                      <ng-select [items]="sourceList" bindLabel="displayname" bindValue="_id"
                        placeholder="Select Source" [(ngModel)]="selected_source"
                        [ngModelOptions]="{ standalone: true }" (change)="getSourceId($event)">
                      </ng-select>
                    </div>

                  </div>
                  <!-- </div>  -->
                  <!-- <div class="row">
                                      <div class='col-12 col-sm-6'>
                                        <label class="form-control-label mb-1" for="college">New Field</label>
                                        <fieldset class="position-relative has-icon-right">
                                          <ng-select [items]="newList" bindLabel="name" placeholder="Select action"
                                            [(ngModel)]="selected_listId" [ngModelOptions]="{standalone: true}" (change)="getChangeListId($event)">
                                          </ng-select>
                                        </fieldset>
                                      </div> 
                                      
                                    </div> -->
                  <div class="row">
                    <div class='col-12 col-sm-6'>
                      <div class="form-group">
                        <label class="form-control-label" for="date">Technology</label>
                        <ng-select [items]="technology_List" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Technology" [(ngModel)]="selectedTechnology"
                          [ngModelOptions]="{ standalone: true }" (change)="getTechnologyId($event)">
                        </ng-select>
                      </div>
                    </div>
                    <div class='col-12 col-sm-6'>
                      <div class="form-group">
                        <label class="form-control-label">Channel</label>
                        <ng-select [items]="channelList" bindLabel="name" bindValue="_id" placeholder="Select Channel"
                          [(ngModel)]="selected_channel" [ngModelOptions]="{standalone: true}"
                          (change)="getChangeChannelId($event)">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class='col-12 col-sm-6'>
                      <label class="form-control-label mb-1" for="college">Invited</label>
                      <fieldset class="position-relative has-icon-right">
                        <ng-select [items]="newList" bindLabel="name" placeholder="Select action"
                          [(ngModel)]="selected_Invite" [ngModelOptions]="{standalone: true}"
                          (change)="getChangeListId($event)">
                        </ng-select>
                      </fieldset>
                    </div>
                    <div class='col-12 col-sm-6'>
                      <label for="last_activedate">Last Active Date</label>
                      <input type="date" class="form-control" [(ngModel)]="this.outsource_lead_model.last_activedate"
                        [ngModel]="this.outsource_lead_model.last_activedate | date: 'yyyy-MM-dd'"
                        [ngModelOptions]="{standalone: true}" [disabled]="false" id="last_activedate"
                        placeholder="Enter last active date" />
                    </div>
                  </div>
                  <div class="row">
                    <div class='col-12 col-sm-6 mt-2'>
                      <div class="form-group">
                        <label class="form-control-label mb-1" for="college">Next Action</label>
                        <fieldset class="position-relative has-icon-right">
                          <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id"
                            placeholder="Select next action" [(ngModel)]="selected_nextaction"
                            [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
                          </ng-select>
                        </fieldset>
                      </div>
                    </div>
                    <div class='col-12 col-sm-6 mt-2'>
                      <div class="form-group">
                        <label for="lastresponse">Last Response</label>
                        <input type="text" class="form-control" [(ngModel)]="outsource_lead_model.lastresponse"
                          [ngModelOptions]="{standalone: true}" id="lastresponse" placeholder="Enter last response" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label" for="coverletter">Cover Letter</label>
                    <textarea class="form-control input-md" ngModel [(ngModel)]="outsource_lead_model.coverletter"
                      [ngModelOptions]="{standalone: true}" #coverletter="ngModel" name="coverletter" id="coverletter"
                      cols="30" rows="4" placeholder="Enter cover letter"></textarea>
                  </div>
                  <div class="row">
                    <div class='col-12 col-sm-6'>
                      <label class="form-control-label" for="notes">Outsource Notes</label>
                      <textarea class="form-control input-md" ngModel [(ngModel)]="outsource_lead_model.notes"
                        [ngModelOptions]="{standalone: true}" #notes="ngModel" name="notes" id="notes" cols="30"
                        rows="1" placeholder="Enter outsource notes"></textarea>
                    </div>
                    <div class='col-12 col-sm-6'>
                      <label class="form-control-label" for="notes">Outsource Admin Notes</label>
                      <textarea class="form-control input-md" ngModel [(ngModel)]="outsource_lead_model.admin_notes"
                        [ngModelOptions]="{standalone: true}" #notes="ngModel" name="notes" id="notes" cols="30"
                        rows="1" placeholder="Enter outsource admin notes"></textarea>
                    </div>
                  </div>

                  <div class="form-group text-center mt-4">

                    <button [disabled]="!outsourceForm.valid" uiSref="result" type="button" class="btn btn-success"
                      (click)="outsourceSubmit()" awResetWizard>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <!-- <aw-wizard-step  [stepTitle]="'Step 2'" [navigationSymbol]="{ symbol: '&#xf0b1;', fontFamily: 'FontAwesome' }">
                      <form #leadForm="ngForm" class="editForm" novalidate>
                        <h4 class="head text-center">Lead Info?</h4>
                        <br/>
                        <div class='row'>
                            <div class='col-12'>
                                <div class="row">
                                    <div class='col-12 col-sm-6 mb-2'>
                                        <label class="form-control-label mb-1" for="college">Next Action</label>
                                        <fieldset class="position-relative has-icon-right">
                                          <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
                                            [(ngModel)]="selected_nextaction" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
                                          </ng-select>
                                        </fieldset>
                                    </div>
                                    <div class='col-12 col-sm-6 mb-2'>
                                        <label class="form-control-label mb-1" for="college">Type</label>
                                        <fieldset class="position-relative has-icon-right">
                                          <ng-select [items]="typeList" bindLabel="displayname" bindValue="_id" placeholder="Select type"
                                            [(ngModel)]="selected_type" [ngModelOptions]="{standalone: true}" (change)="getChangeType($event)">
                                          </ng-select>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="row">
                                  <div class='col-12 col-sm-6'>
                                    <label class="form-control-label mb-1" for="college">Lead Status</label>
                                    <fieldset class="position-relative has-icon-right">
                                      <ng-select [items]="leadstatuslist" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
                                        [(ngModel)]="selected_lead_status" [ngModelOptions]="{standalone: true}" (change)="getLeadStatusId($event)">
                                      </ng-select>
                                    </fieldset>
                                  </div>
                                
                                </div>
                                <div class="row">
                                    <div class='col-12 col-sm-6'>
                                      <label class="form-control-label mb-1" for="college">Lead Stage</label>
                                      <fieldset class="position-relative has-icon-right">
                                        <ng-select [items]="leadstageList" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
                                          [(ngModel)]="selected_lead_stage" [ngModelOptions]="{standalone: true}" (change)="getLeadStageId($event)">
                                        </ng-select>
                                      </fieldset>
                                    </div>
                                                                   
                                </div>
                               
                                <div class="form-group text-center mt-2">
                                
                                </div>
                            </div>
                        </div>
                    </form>
                     
                    </aw-wizard-step> -->

        </aw-wizard>


      </div>
    </div>
  </div>
  <div _ngcontent-fdm-c126="" class="buy-now">
    <a _ngcontent-fdm-c126="" routerLink="/leads/outsource-leads" class="btn btn-danger">Back To Outsource Leads</a>
  </div>
</section>